import React from 'react';
import "./notfound.css"
import { useNavigate } from 'react-router';
import Header from '../../component/loaderComponent/Header/Header';

const NotFoundPage = () => {
    const navigate = useNavigate();
    return (
        <main class="bl_page404">
            <Header title={"Page Not Found"}/>
            <h1>Error 404. The page does not exist</h1>
            <p>Sorry! The page you are looking for can not be found. Perhaps the page you requested was moved or deleted. It is also possible that you made a small typo when entering the address. Go to the main page.
            </p>
            <div class="bl_page404__wrapper">
                <img src="https://github.com/BlackStar1991/Pictures-for-sharing-/blob/master/404/bigBoom/cloud_warmcasino.png?raw=true" alt="cloud_warmcasino.png" />
                <div class="bl_page404__el1"></div>
                <div class="bl_page404__el2"></div>
                <div class="bl_page404__el3"></div>
                <span class="bl_page404__link cursor_pointer" onClick={() => navigate("/pgmlist")}>go home</span>
            </div>
        </main>
    );
}

export default NotFoundPage;
